import ElementEnum from '@iris.interactive/handcook/public/scripts/enumerators/element.enum'

export default class ScrollRevealService {
    constructor() {
        const scrollRevealParent = document.querySelectorAll(ElementEnum.scrollRevealParent)
        const scrollReveal = document.querySelectorAll(ElementEnum.scrollReveal)

        //Add scrollreveal attributs on Wordpress natives blocs
        const blocs = $(
            '.blocks-gallery-grid, .wp-block-gallery, .wp-block-media-text, .wp-block-columns',
        )
        if (blocs.length > 0) {
            blocs.attr('data-hc-scroll-reveal-parent', '')
            blocs.attr('data-hc-scroll-reveal-interval', '300')
        }

        if (scrollRevealParent.length > 0 || scrollReveal.length > 0) {
            import(
                '@iris.interactive/handcook/public/scripts/components/scroll-reveal/scroll-reveal.component' /* webpackChunkName: "scripts/hc_scroll_reveal" */
            ).then(({ default: hc_scroll_reveal }) => {
                hc_scroll_reveal()
            })
        }
    }
}
